module.exports = __webpack_public_path__ + "img/172.96ebecb9.jpg";